/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" strokeWidth="2" d="M13.844 10.156h9.033a11.02 11.02 0 00-9.033-9.033v9.033z" />
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M20.35 19.18h0a10.972 10.972 0 002.527-5.367h-12.69V1.123a11.017 11.017 0 00-9.15 11.784c.433 5.334 4.768 9.648 10.104 10.06h0a10.97 10.97 0 007.581-2.248h0c.17-.13.337-.28.518-.45l.631-.597.001-.001c.18-.17.338-.329.478-.49z"
      />
    </svg>
  );
});

IconComponent.displayName = 'IconBusinessAnalytics24';

export const IconBusinessAnalytics24: React.FC<ISVGIconProps> = createIcon(IconComponent);
